// import { EmojiObjectsTwoTone } from '@material-ui/icons';
import React from 'react';
import cssHistoryWindow from './HistoryWindow.module.scss';
import {GlobalLibs} from 'bc-react-package'

const COMP_NAME = "HistoryWindow"

function HistoryWindow(props)
{
    console.log(COMP_NAME + ".Begin")
    console.log("HistoryWindow.props:", props)

    // summary: 點選 關閉
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "HistoryWindowClose"
        }
        props.CallbackRef(objCallbackData)
    }

    function LastSavedOnTapHandler()
    {
        console.log(COMP_NAME + ".LastSavedOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "HistoryWindowLastSaved"
        }
        props.CallbackRef(objCallbackData)
    }

    // summary: 點選 考卷詳細按鈕
    function DetailOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".DetailOnTapHandler", AssignmentIndex)

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "HistoryWindowDetail",
            "AssignmentIndex": AssignmentIndex
        }
        props.CallbackRef(objCallbackData)
    }

    function GetPracticeLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GetPracticeLU");
        console.log("window.garrPracticeLU: ", window.garrPracticeLU)
        
        let objPracticeLU = null;
        let intIndex = 0;
        let intCount = window.garrPracticeLU.length;
        let blnFound = false;

        while ((!blnFound) && (intIndex < intCount))
        {
            if (window.garrPracticeLU[intIndex].LUCatSeqNo === LUCatSeqNo)
            {
                objPracticeLU = window.garrPracticeLU[intIndex];
                blnFound = true;
            }
            intIndex++;
        }

        return objPracticeLU;
    }

    function RenderTempAnswerRow(AssignmentTempAns)
    {
        // console.log(COMP_NAME + ".RenderTempAnswerRow: ", AssignmentTempAns);

        let arrDate = AssignmentTempAns.TestedTime.split(" ");
        console.log('arrDate: ', arrDate);
        let strDateWithFormat = window.Globals.GetDateWithFormat(AssignmentTempAns.TestedTime.ToUTC().ToBCLocalTimeString(), window.gDateTimeFormatEnum.DateAndTime)

        return (
            <div className={cssHistoryWindow.divListRow}>
                <div className={cssHistoryWindow.divListCell}>
                    {strDateWithFormat}
                </div>

                <div className={cssHistoryWindow.divListCell}>
                    {window.gAppUI.LBL_NotScore}
                </div>

                <div className={cssHistoryWindow.btnLastSaved} onClick={() => LastSavedOnTapHandler()}>
                    {window.gAppUI.LBL_LastSaved}
                </div>
            </div>
        )
    }

    // summary: Render 內容 選擇
    function RenderAssignmentRow(AssignmentData, AssignmentIndex)
    {
        // console.log(COMP_NAME + ".RenderAssignmentRow", AssignmentData);

        let strScore = "";
        let strDateWithFormat = window.Globals.GetDateWithFormat(AssignmentData.TestedTime.ToUTC().ToBCLocalTimeString(), window.gDateTimeFormatEnum.DateAndTime)
        // console.log("strDateWithFormat:", strDateWithFormat)

        let arrDate = AssignmentData.TestedTime.split(" ");
        console.log('arrDate: ', arrDate);

        if (
            (typeof (AssignmentData.Score) !== 'undefined') &&
            (AssignmentData.Score !== null)
        )
        {
            strScore = AssignmentData.Score
        }
        else
        {
            strScore = window.gAppUI.LBL_NotScore
        }

        return (
            <div className={cssHistoryWindow.divListRow}>
                <div className={cssHistoryWindow.divListCell}>
                    {strDateWithFormat}
                </div>

                <div className={cssHistoryWindow.divListCell}>
                    {strScore}
                </div>

                <div className={cssHistoryWindow.btnDetail} onClick={() => DetailOnTapHandler(AssignmentIndex)}>
                    {window.gAppUI.BTN_Detail}
                </div>
            </div>
        )
    }

    function RenderContent()
    {
        // console.log(COMP_NAME + ".RenderContent");

        
            let objPracticeLU = GetPracticeLU(parseInt(props.LUCatSeqNo))
            let intLessonID = parseInt(props.LessonID) % 100;
            let strTitle = window.gAppUI.LBL_Lesson + " " + intLessonID + " " + objPracticeLU.DisplayName;

            let objTempAnswerArea = null
            if ((props.AssignmentTempAns !== null) && (props.AssignmentTempAns.TestedTime !== null))
            {
                objTempAnswerArea = RenderTempAnswerRow(props.AssignmentTempAns)
            }
            return (
                <div>
                    <div className={cssHistoryWindow.divTitleText}>
                        {strTitle}
                    </div>

                    <div className={cssHistoryWindow.divListTitleMain}>
                        <div className={cssHistoryWindow.divCellTitle}>
                            {window.gAppUI.LBL_Date}
                        </div>
                        <div className={cssHistoryWindow.divCellTitle}>
                            {window.gAppUI.LBL_Score}
                        </div>
                    </div>

                    <div className={cssHistoryWindow.divListContentMain}>
                        {objTempAnswerArea}
                        {props.AssigementHistoryList.map((Result, Index) =>
                            <div key={Index}>
                                {RenderAssignmentRow(Result, Index)}
                            </div>
                        )}
                    </div>
                </div>
            )
       
    }

    return (
        <div className={cssHistoryWindow.divMask}>
            <div className={cssHistoryWindow.divMain}>
                <div className={cssHistoryWindow.btnClose} onClick={() => CloseOnTapHandler()} />
                {RenderContent()}
            </div>
        </div>
    )
}

export default HistoryWindow
